import { Link } from "react-router-dom";
import { FileText, Clock } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { useCompactLayout } from "@/hooks/use-compact-layout";
import ConversationsPanel from "@/components/conversations/ConversationsPanel";
import { Button } from "@/components/ui/button";
import { CONVERSATIONS } from "@/constants/testIds";

/** Pagina standalone de Conversaciones (Recepcion + Admin). El Admin
 * tambien puede acceder a este mismo panel embebido dentro de /agente. */
export default function ConversationsPage() {
  const compact = useCompactLayout();
  const { user } = useAuth();
  return (
    // Fix AI (2026-10-23): alto visible real (dvh): 100dvh menos el encabezado (4rem) y el relleno de arriba y abajo (2, 3 o 4rem)
    <div className="flex flex-col h-[calc(100dvh-6rem)] sm:h-[calc(100dvh-7rem)] lg:h-[calc(100dvh-8rem)]">
      <div className={`${compact ? "mb-2" : "mb-4"} flex items-center sm:items-start justify-between gap-4 flex-wrap`}>
        <div>
          <h1 className={`font-serif tracking-tight text-foreground ${compact ? "text-2xl" : "text-3xl sm:text-4xl"}`}>Conversaciones</h1>
          {!compact && <p className="text-base text-muted-foreground mt-1">WhatsApp - Agente de IA con escalado a humano.</p>}
        </div>
        {/* Fix AC (2026-10-15): plantillas de WhatsApp */}
        <div className="flex items-center gap-2 flex-wrap">
          {/* Fix AN (2026-10-23): mensajes automaticos (solo admin) */}
          {user?.role === "admin" && (
            <Button asChild variant="outline" className={`gap-1.5 ${compact ? "h-10" : ""}`} data-testid={CONVERSATIONS.autoMessagesPageButton}>
              <Link to="/conversaciones/automaticos"><Clock className="w-4 h-4" /> Automáticos</Link>
            </Button>
          )}
          <Button asChild variant="outline" className={`gap-1.5 ${compact ? "h-10" : ""}`} data-testid={CONVERSATIONS.templatesPageButton}>
            <Link to="/conversaciones/plantillas"><FileText className="w-4 h-4" /> Plantillas</Link>
          </Button>
        </div>
      </div>
      <ConversationsPanel heightClass="flex-1 min-h-0" />
    </div>
  );
}
